import React from 'react';
import { Smartphone, FileText, Zap, ShieldCheck, MapPin } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToModules = () => {
    document.getElementById('modules')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy text-white pt-16 pb-20 px-4 relative overflow-hidden" data-id="element-160">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=2000&auto=format&fit=crop')] opacity-10 bg-cover bg-center mix-blend-overlay" data-id="element-161"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-162">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-sm font-medium text-sky mb-8" data-id="element-163">
          <Smartphone className="w-4 h-4" data-id="element-164" />
          <span data-id="element-165">Instagram & Facebook · Argentina 2026</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-166">
          Aprendé a vender en Instagram y Facebook en 7 días y conseguí tus
          primeros compradores en 30
        </h1>

        <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-167">
          El único sistema completo en español para emprendedores argentinos que
          quieren convertir sus redes en una máquina de ventas — aunque nunca
          hayan hecho publicidad antes.
        </p>

        <p className="text-xs text-slate-400 mb-10 max-w-2xl mx-auto" data-id="element-168">
          * Resultados estimados basados en datos de mercado. Los tiempos y
          resultados dependen del esfuerzo y aplicación de cada persona. No es
          una garantía de ingreso.
        </p>

        <div className="relative mx-auto w-full max-w-lg mb-12 rounded-2xl border border-white/10 shadow-2xl overflow-hidden" data-id="element-169">
          <img src="https://cdn.magicpatterns.com/uploads/ktcce3FjPx8zih7B43H5vM/WhatsApp_Image_2026-06-03_at_7.29.02_PM_(1).jpg" alt="Mega Pack Publicidad en Redes Sociales — 6 guías y 4 bonos incluidos" className="w-full h-auto block" data-id="element-170" />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-171">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-sky hover:bg-sky-hover text-navy font-bold text-lg px-8 py-4 rounded-xl shadow-[0_0_20px_rgba(56,189,248,0.4)] transition-all hover:scale-105 flex items-center justify-center gap-2" data-id="element-172">
            <span className="text-2xl" data-id="element-173">💥</span> QUIERO MI PACK AHORA
          </button>

          <button onClick={scrollToModules} className="w-full sm:w-auto bg-white/5 hover:bg-white/10 border border-white/20 text-white font-medium text-lg px-8 py-4 rounded-xl transition-all" data-id="element-174">
            Ver qué incluye ↓
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium text-slate-300" data-id="element-175">
          <div className="flex items-center gap-2" data-id="element-176">
            <FileText className="w-5 h-5 text-sky" data-id="element-177" />
            <span data-id="element-178">PDF Digital</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-179">
            <Zap className="w-5 h-5 text-sky" data-id="element-180" />
            <span data-id="element-181">Acceso Inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-182">
            <ShieldCheck className="w-5 h-5 text-sky" data-id="element-183" />
            <span data-id="element-184">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-185">
            <MapPin className="w-5 h-5 text-sky" data-id="element-186" />
            <span data-id="element-187">Hecho en Argentina</span>
          </div>
        </div>
      </div>
    </section>;
}